import {
  IDefaultSchema,
  DatahubEntity,
  WatchtimeAction,
  IWatchtimeSchema,
  DATA_VERSION,
  CaptureEventData,
  CaptureEvent,
} from 'src/interfaces/Datahub';

import watchtimeSchema from './schema';

interface IWatchtimeData {
  startTime: number;
  endTime: number;
}
class Watchtime {
  defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  get schema() {
    return watchtimeSchema;
  }

  measure(captureEvent: CaptureEvent<WatchtimeAction>, { startTime, endTime }: IWatchtimeData) {
    if (startTime > endTime) return;

    const event: IWatchtimeSchema = {
      ...this.defaultData,
      endTime,
      startTime,
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['2.0'],
    };

    captureEvent(DatahubEntity.WATCHTIME, WatchtimeAction.MEASURE, data);
  }
}
export default Watchtime;
